import { useCallback, useState } from 'react';

/**
 * Reference-counted busy flag for overlapping async operations.
 * Always pair begin() with end() in try/finally.
 */
export function useBusyCount() {
  const [count, setCount] = useState(0);
  const begin = useCallback(() => {
    setCount((c) => c + 1);
  }, []);
  const end = useCallback(() => {
    setCount((c) => Math.max(0, c - 1));
  }, []);
  const busy = count > 0;
  return { busy, begin, end };
}
